module.exports = __webpack_public_path__ + "images/growth-inst2.png";